import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseStaffSearch } from "@/features/accounts";
import { StaffPage } from "@/features/accounts/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/settings/staff/")({
  validateSearch: strictSearch(parseStaffSearch),
  component: Staff,
});

function Staff() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <StaffPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(userId) =>
        router.buildLocation({ to: "/settings/staff/$userId", params: { userId } }).href
      }
      onOpen={(userId) =>
        void router.navigate({ to: "/settings/staff/$userId", params: { userId } })
      }
    />
  );
}
